import { Outlet } from "react-router-dom";
import { BottomNav } from "@/components/BottomNav";

export const OceanBackground = ({ variant = "deep" }) => (
  <div className="pointer-events-none fixed inset-0 z-0" aria-hidden="true">
    {variant === "sheen" ? (
      <div
        className="absolute inset-x-0 top-0 h-[38vh]"
        style={{
          background:
            "radial-gradient(900px circle at 20% 10%, rgba(34,211,238,0.16), transparent 55%), radial-gradient(700px circle at 80% 0%, rgba(147,197,253,0.10), transparent 50%)",
        }}
      />
    ) : (
      <div
        className="absolute inset-x-0 top-0 h-[32vh]"
        style={{
          background:
            "radial-gradient(800px circle at 50% -10%, rgba(45,212,191,0.10), transparent 55%), radial-gradient(600px circle at 15% 0%, rgba(34,211,238,0.08), transparent 50%)",
        }}
      />
    )}
    <div className="noise-overlay" />
  </div>
);

export const AppShell = () => {
  return (
    <div className="relative min-h-screen">
      <OceanBackground />
      <main className="relative z-10 max-w-md mx-auto px-4 pt-[max(1.25rem,env(safe-area-inset-top))] pb-32">
        <Outlet />
      </main>
      <BottomNav />
    </div>
  );
};
